import { Drawer, DrawerHeader, IconButton, } from '@one-thd/sui-atomic-components';
import { Close, ArrowBack } from '@one-thd/sui-icons';
import React, { useState, useEffect } from 'react';
import { EditDeliveryAddressChangeForm } from './EditDeliveryAddressChangeForm';
import { EditDeliveryAddressConfirmation } from './EditDeliveryAddressConfirmation';
import { EditDeliveryAddressSurvey } from './EditDeliveryAddressSurvey';
import { getWindow } from '../../../utils/general';
import { SubmitDeliveryAddressSuspendCart } from '../../../api/oms/edit-delivery-address';
export var EditDeliveryAddressDrawer = function (_a) {
    var open = _a.open, setOpen = _a.setOpen, setDrawerError = _a.setDrawerError, setGetCitiesByZipCode = _a.setGetCitiesByZipCode, orderDetailsData = _a.orderDetailsData, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentType = _a.fulfillmentType, orderId = _a.orderId, customerType = _a.customerType, fulfillmentGroupIndex = _a.fulfillmentGroupIndex, getCitiesByZipCode = _a.getCitiesByZipCode, isChangeForm = _a.isChangeForm, setIsChangeForm = _a.setIsChangeForm;
    var _b = useState(false), isConfirmation = _b[0], setIsConfirmation = _b[1];
    var _c = useState(false), isSurvey = _c[0], setIsSurvey = _c[1];
    var _d = useState(), editDeliveryAddressOrderIds = _d[0], setEditDeliveryAddressOrderIds = _d[1];
    var _e = useState(), suspendCartData = _e[0], setSuspendCartData = _e[1];
    var _f = useState(false), isAddressChangeConfirmed = _f[0], setIsAddressChangeConfirmed = _f[1];
    var _g = useState(), updatedAddressData = _g[0], setUpdatedAddressData = _g[1];
    var _h = useState({}), newDeliveryAddressDetails = _h[0], setNewDeliveryAddressDetails = _h[1];
    var suspendCartCheck = function () {
        if (suspendCartData && !isAddressChangeConfirmed) {
            SubmitDeliveryAddressSuspendCart(suspendCartData, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId);
            setSuspendCartData(undefined);
        }
    };
    var closeDrawer = function () {
        var _a, _b;
        setOpen(false);
        suspendCartCheck();
        setIsConfirmation(false);
        setIsSurvey(false);
        if (isAddressChangeConfirmed) {
            setIsAddressChangeConfirmed(false);
            (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.reload();
        }
    };
    var goBack = function () {
        if (isConfirmation) {
            setIsChangeForm(true);
            setIsConfirmation(false);
            suspendCartCheck();
            return;
        }
        closeDrawer();
    };
    useEffect(function () {
        var _a;
        if (editDeliveryAddressOrderIds) {
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('editDeliveryAddressOrderIds', JSON.stringify(editDeliveryAddressOrderIds));
        }
    }, [editDeliveryAddressOrderIds]);
    useEffect(function () {
        var _a;
        var onBeforeUnload = function () {
            suspendCartCheck();
        };
        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.addEventListener('beforeunload', onBeforeUnload);
        return function () {
            var _a;
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.removeEventListener('beforeunload', onBeforeUnload);
            suspendCartCheck();
        };
    }, []);
    useEffect(function () {
        if (updatedAddressData) {
            setSuspendCartData({
                cartId: updatedAddressData.ordersInfo.data.newOrder.cartId,
                orderId: orderId,
                emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
                net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
            });
        }
    }, [updatedAddressData]);
    var handleDrawerHeader = function () {
        if (isConfirmation) {
            return 'Confirm Delivery Address';
        }
        return 'Edit Delivery Address';
    };
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-full sui-w-96" },
        React.createElement(Drawer, { open: open, onClose: closeDrawer, position: "right" },
            React.createElement(DrawerHeader, { title: handleDrawerHeader(), endAdornment: React.createElement(IconButton, { "aria-label": "drawer-close", onClick: closeDrawer, icon: Close }), startAdornment: !isChangeForm && (React.createElement(IconButton, { "aria-label": "go-back", onClick: goBack, icon: ArrowBack })) }),
            isChangeForm && (React.createElement(EditDeliveryAddressChangeForm, { orderDetailsData: orderDetailsData, fulfillmentGroup: fulfillmentGroup, getCitiesByZipCode: getCitiesByZipCode, closeDrawer: closeDrawer, setGetCitiesByZipCode: setGetCitiesByZipCode, setIsChangeForm: setIsChangeForm, setDrawerError: setDrawerError, fulfillmentGroupIndex: fulfillmentGroupIndex, setIsConfirmation: setIsConfirmation, setUpdatedAddressData: setUpdatedAddressData, setNewDeliveryAddressDetails: setNewDeliveryAddressDetails })),
            isConfirmation && updatedAddressData && (React.createElement(EditDeliveryAddressConfirmation, { closeDrawer: closeDrawer, updatedAddressData: updatedAddressData, newDeliveryAddressDetails: newDeliveryAddressDetails, orderDetailsData: orderDetailsData, fulfillmentGroup: fulfillmentGroup, fulfillmentType: fulfillmentType, setIsChangeForm: setIsChangeForm, setIsConfirmation: setIsConfirmation, setIsSurvey: setIsSurvey, setDrawerError: setDrawerError, fulfillmentGroupIndex: fulfillmentGroupIndex, setEditDeliveryAddressOrderIds: setEditDeliveryAddressOrderIds, suspendCartCheck: suspendCartCheck, setIsAddressChangeConfirmed: setIsAddressChangeConfirmed })),
            isSurvey && (React.createElement(EditDeliveryAddressSurvey, { closeDrawer: closeDrawer, orderId: orderId, fulfillmentGroup: fulfillmentGroup, fulfillmentType: fulfillmentType, orderDetailsData: orderDetailsData, customerType: customerType })))));
};
